var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaCarBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 383,
    viewBox: "0 0 399 383",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4363 192.41C121.93 207.664 159.186 52.0626 247.769 13.8914C336.352 -24.2798 295.479 14.5384 378.868 172.761C462.258 330.983 255.439 224.856 162.536 351.279C69.6323 477.702 -59.0579 177.156 31.4363 192.41Z",
    fill: "#24C1A8",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaCarBack);
export default __webpack_public_path__ + "static/media/idea_car_back.107d3dd84586b8b38e67973fc7614b6b.svg";
export { ForwardRef as ReactComponent };